// extracted by mini-css-extract-plugin
export default {"calendar":"ReservationManagement_calendar__vJJ8m","event":"ReservationManagement_event__HLvz8","paidItems":"ReservationManagement_paidItems__uS-Yb"};